import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import execute from './get';
import { useQuery as useReactQuery, useSuspenseQuery as useSuspenseReactQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
/**
 * Returns a query key that should be used with useQuery.
 *
 * Disclaimer: Do not use this with useInfiniteQuery, prefer getInfiniteQueryKey.
 */
export function getQueryKey(options) {
  return ["/api/help-center/access-control", options];
}
/**
 * Returns a query key that should be used with useInfiniteQuery.
 */
export function getInfiniteQueryKey(options) {
  return ['infinite'].concat(_toConsumableArray(getQueryKey(options)));
}
export function getQueryFn(options) {
  return function (_ref) {
    var signal = _ref.signal;
    var optionsWithSignal = _objectSpread(_objectSpread({}, options), {}, {
      signal: signal
    });
    return execute(optionsWithSignal);
  };
}
export function useQuery(reactQueryOptions, options) {
  return useReactQuery(_objectSpread({
    queryKey: getQueryKey(options),
    queryFn: getQueryFn(options)
  }, reactQueryOptions));
}
export function useSuspenseQuery(suspenseReactQueryOptions, options) {
  return useSuspenseReactQuery(_objectSpread({
    queryKey: getQueryKey(options),
    queryFn: getQueryFn(options)
  }, suspenseReactQueryOptions));
}
export function usePrefetchQuery() {
  var queryClient = useQueryClient();
  var prefetch = useCallback(function (fetchQueryOptions, options) {
    return queryClient.prefetchQuery(_objectSpread({
      queryKey: getQueryKey(options),
      queryFn: getQueryFn(options)
    }, fetchQueryOptions));
  }, [queryClient]);
  return prefetch;
}
/**
 * Returns a function that invalidates the query for this endpoint.
 * After being invalidated the query will be refetched on the next useQuery call.
 */
export function useInvalidateQuery() {
  var queryClient = useQueryClient();
  var invalidate = useCallback(function (options, invalidateQueryFilters, invalidateOptions) {
    return queryClient.invalidateQueries(_objectSpread({
      queryKey: getQueryKey(options)
    }, invalidateQueryFilters), invalidateOptions);
  }, [queryClient]);
  return invalidate;
}
/**
 * Returns a function that invalidates the infinite query for this endpoint.
 * After being invalidated the query will be refetched on the next useInfiniteQuery call.
 */
export function useInvalidateInfiniteQuery() {
  var queryClient = useQueryClient();
  var invalidate = useCallback(function (options, invalidateQueryFilters, invalidateOptions) {
    return queryClient.invalidateQueries(_objectSpread({
      queryKey: getInfiniteQueryKey(options)
    }, invalidateQueryFilters), invalidateOptions);
  }, [queryClient]);
  return invalidate;
}